









































































































































































































































































































import BaseComponent from '@/core/base.component';
import Component from 'vue-class-component';
import {
  AdminDto,
  DeliveryFounderConsultDto,
  DeliveryFounderConsultListDto,
  FounderConsultDto,
  SpaceTypeDto,
} from '@/dto';
import { BaseUser } from '@/services/shared/auth';
import AdminService from '@/services/admin.service';
import SpaceTypeService from '@/services/space-type.service';
import FounderConsultService from '@/services/founder-consult.service';
import { getStatusColor } from '../../../core/utils/status-color.util';
import { Pagination } from '@/common';
import { APPROVAL_STATUS } from '@/services/shared';
import toast from '../../../../resources/assets/js/services/toast.js';
import DeliveryFounderConsultService from '../../../services/delivery-founder-consult.service';

@Component({
  name: 'MyPageDetail',
})
export default class MyPageDetail extends BaseComponent {
  private myPageDto: AdminDto = new AdminDto(BaseUser);
  private myPageUpdateDto: AdminDto = new AdminDto(BaseUser);
  private pagination = new Pagination();
  private paginationCounsults = new Pagination();
  private paginationDeliveryConsults = new Pagination();
  private founderConsultList: FounderConsultDto[] = [];
  private founderConsultTotalCount = null;
  private deliveryFounderConsultList: DeliveryFounderConsultDto[] = [];
  private deliveryFounderConsultTotalCount = null;
  private dataLoading = false;
  private dataLoadingDelivery = false;
  private spaceTypes: SpaceTypeDto[] = [];

  // get status color
  getStatusColor(status: APPROVAL_STATUS) {
    return getStatusColor(status);
  }

  findSpaceType() {
    SpaceTypeService.findForSelect().subscribe(res => {
      this.spaceTypes = res.data;
    });
  }

  findOne() {
    AdminService.findMe().subscribe(res => {
      if (res) {
        this.myPageDto = res.data;
        this.myPageUpdateDto = this.myPageDto;
      }
    });
  }

  findConsults(isPagination?: boolean) {
    if (!isPagination) {
      this.paginationCounsults.page = 1;
    }
    this.paginationCounsults.limit = 5;
    this.dataLoading = true;
    FounderConsultService.findMyConsults(this.paginationCounsults).subscribe(
      res => {
        this.dataLoading = false;
        this.founderConsultList = res.data.items;
        this.founderConsultTotalCount = res.data.totalCount;
      },
    );
  }

  findDeliveryConsults(isPagination?: boolean) {
    if (!isPagination) {
      this.paginationDeliveryConsults.page = 1;
    }
    this.paginationDeliveryConsults.limit = 5;
    this.dataLoadingDelivery = true;
    DeliveryFounderConsultService.findMyConsults(
      this.paginationDeliveryConsults,
    ).subscribe(res => {
      if (res) {
        this.dataLoadingDelivery = false;
        this.deliveryFounderConsultList = res.data.items;
        this.deliveryFounderConsultTotalCount = res.data.totalCount;
      }
    });
  }

  updateSelf(password) {
    AdminService.updateSelf(
      this.myPageDto.no,
      password ? this.myPageUpdateDto : this.myPageDto,
    ).subscribe(res => {
      if (res) {
        toast.success('수정완료');
        this.findOne();
      }
    });
  }

  clearOutUpdateDto() {
    this.myPageUpdateDto = new AdminDto(BaseUser);
  }

  paginateRestaurantConsult() {
    this.findConsults(true);
  }

  paginateDeliveryConsults() {
    this.findDeliveryConsults(true);
  }

  created() {
    this.findOne();
    this.findConsults();
    this.findSpaceType();
  }
}
